var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "overlay" }, [
      _vm.$route.name === "Home"
        ? _c(
            "div",
            [
              _vm._m(0),
              _vm._v(" "),
              _c("img", {
                staticClass: "tap",
                attrs: { src: require("@/assets/アセット 8@2x.png") }
              }),
              _vm._v(" "),
              _c("router-link", { attrs: { to: "/other" } }, [
                _c("div", { staticClass: "other" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/footer/アセット 19@2x.png")
                    }
                  })
                ])
              ])
            ],
            1
          )
        : _c("div", [_vm._m(1)])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "overlay-body" }, [
      _c("p", { staticClass: "tutorial-text" }, [
        _vm._v("まずはじめに"),
        _c("br"),
        _vm._v("基本データ"),
        _c("br"),
        _vm._v("健康度チェック"),
        _c("br"),
        _vm._v("をしましょう")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        staticClass: "other-tap",
        attrs: { src: require("@/assets/アセット 8@2x.png") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c1c6c8e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c1c6c8e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tutorial.vue
// module id = null
// module chunks = 